import books from '../data/socialBooks.json';
import formatBibleReading from './formatBibleReading';
import { extractSocialVerses } from './socialBible';

export const SOCIAL_COLLECTIONS = {
  old: { label: '旧約', icon: '/static/images/social-icons/old.webp' },
  new: { label: '新約', icon: '/static/images/social-icons/new.webp' },
  apocrypha: { label: '外典', icon: '/static/images/social-icons/apocrypha.webp' },
};
const cache = new Map();
export function pickGlobalSocialBooks(random = Math.random) {
  return Object.keys(SOCIAL_COLLECTIONS).flatMap(collection => {
    const pool = books.filter(book => book.collection === collection);
    for (let i = pool.length - 1; i > 0; i--) {
      const j = Math.floor(random() * (i + 1));
      [pool[i], pool[j]] = [pool[j], pool[i]];
    }
    return pool.slice(0, 2);
  });
}

export async function loadGlobalSocialPool(signal, random = Math.random) {
  const selected = pickGlobalSocialBooks(random);
  const requests = selected.flatMap(book => ['norm', ...(book.gal ? ['gal'] : [])].map(async type => {
    const key = `${book.book}:${type}`;
    if (cache.has(key)) return cache.get(key);
    const response = await fetch(`${process.env.PUBLIC_URL}/static/html/${type}/${book.book}.htm`, { signal });
    if (!response.ok) throw new Error('Book unavailable');
    const html = await response.text();
    if (signal.aborted) throw new Error('Aborted');
    const verses = extractSocialVerses(type === 'norm' ? formatBibleReading(html) : html).map(item => ({
      ...item, id: `${book.book}:${item.id}`, book: book.book, bookName: book.bookName, collection: book.collection, type,
    }));
    if (!verses.length) throw new Error('Book has no verses');
    cache.set(key, verses);
    if (cache.size > 24) cache.delete(cache.keys().next().value);
    return verses;
  }));
  const results = await Promise.allSettled(requests);
  if (signal.aborted) throw new Error('Aborted');
  const all = results.filter(result => result.status === 'fulfilled').flatMap(result => result.value);
  if (!all.length) throw new Error('No books loaded');
  return { norm: all.filter(item => item.type === 'norm'), gal: all.filter(item => item.type === 'gal'), partial: results.some(result => result.status === 'rejected') };
}

// Keep all three collections represented without losing the ranking within each.
export function interleaveSocialCollections(cards) {
  const groups = Object.keys(SOCIAL_COLLECTIONS).map(collection => cards.filter(card => card.item.collection === collection));
  const result = [];
  const length = Math.max(0, ...groups.map(group => group.length));
  for (let index = 0; index < length; index++) for (const group of groups) if (group[index]) result.push(group[index]);
  return result;
}
